
import {RouteConfig} from "vue-router";
const ServersDashboard = () => import('../views/servers/ServersDashboard.vue');

let shop: RouteConfig[] = [
    {
        name: 'servers',
        path: '/servers',
        component: ServersDashboard,
        meta: {
            allowLoggedOut: true,
        },
    },
];

export default shop;
